export function isApiError(data) {
    if (typeof data !== 'object' || data === null) {
        return false;
    }
    return 'error' in data || 'errors' in data;
}
export function getApiErrorMessage(data) {
    if (data.error) {
        return data.error;
    }
    if (data.errors) {
        if (typeof data.errors === 'string') {
            return data.errors;
        }
        if (data.errors.length > 0) {
            return data.errors.join(', ');
        }
    }
    return 'Неизвестная ошибка';
}
